import { useEffect, useState } from 'react';

import { first, get, round as lodashRound } from 'lodash';

import { notifyError, notifySuccess } from 'utils/notifications';

export const copyToClipboard = (copyText, msg = 'Copied to clipboard.') => {
  navigator.clipboard.writeText(copyText).then(
    () => {
      notifySuccess(msg);
    },
    (error) =>
      notifyError(
        `Failed to copy ${copyText} to the clipboard. The error was: ${error}`
      )
  );
};

export function humanReadableFileSize(bytes, round) {
  const bytesPow = Math.floor(Math.log(bytes) / Math.log(1024));
  const sizes = ['B', 'kB', 'MB', 'GB']; // We don't need more than that

  const humanReadbleSize = lodashRound(bytes / Math.pow(1024, bytesPow), round);

  return `${humanReadbleSize} ${sizes[bytesPow]}`;
}

export async function sleep(ms) {
  await new Promise((r) => setTimeout(r, ms));
}

export function noop() {}
export function noopPromise() {
  return new Promise((res) => res());
}

export const randomNumber = () => Math.round(Math.random() * 100000);

export const identity = (x) => x;

export const useCaching = (obj) => {
  const [cachedObj, setCachedObj] = useState(obj);

  useEffect(() => {
    setCachedObj(obj);
  }, [obj]);

  return [cachedObj, setCachedObj];
};

export const getStandardButtonLabel = ({ standards }) => {
  const standardsCount = get(standards, 'length', 0);

  if (standardsCount === 0) {
    return 'Standards';
  }

  if (standardsCount === 1) {
    return get(first(standards), 'code', 'short_description');
  }

  return `${standardsCount} Standards`;
};

export const getItemFromLocalStorage = ({ item }) =>
  JSON.parse(localStorage.getItem(item));

export const bytesToMegaBytes = (bytes) => bytes / 1024 ** 2;

// Calculates the percentage of the first number (numerator) compared to the second number (denominator).
export const parsePercentage = ({ firstNumber, secondNumber }) => {
  if (firstNumber === 0 || secondNumber === 0) {
    return 0;
  }

  const percentage = (firstNumber / secondNumber) * 100;

  return percentage;
};

export const capitalize = ({ str }) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const pluralize = ({ noun, count, pluralForm = 's' }) => {
  return count > 1 ? `${noun}${pluralForm}` : noun;
};

export const cutText = ({ text, char }) => {
  if (text === '' || text === undefined) {
    return '';
  }

  if (char >= text.length) {
    return text;
  }

  return `${text.slice(0, char)}...`;
};
